module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-01.3c493600.jpg";